import React from 'react';
// import ReactDOM from "react-dom";
import style from './searchBox-style.js';
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";

import Tooltip from '@material-ui/core/Tooltip';
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
// import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import SearchIcon from "@material-ui/icons/Search";
// import Person from "@material-ui/icons/Person";
// import Company from "@material-ui/icons/Domain";

import AutoSuggest from "react-autosuggest";
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';

import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";

import SearchService from "../../services/api/SearchService";
import { AppBar, IconButton, Tab, Tabs } from '@material-ui/core';
// import CardBody from '../CardBody/CardBody.js';

class SearchBox extends React.PureComponent {
  constructor(props) {
    super(props);
    this.searchService = new SearchService();
    this.state = {
      value: '',
      suggestions: [],
      expanded: false,
    };
    this.ref = React.createRef();
  }
  componentDidMount() {
    this.timer = null;
    // var component = ReactDOM.findDOMNode(this.refs.container).offsetTop;
    // this.props.changeOnHeight(component);
    // window.addEventListener("scroll", this.handleScroll);
  }
  // componentWillUnmount() {
  //     window.removeEventListener("scroll", this.handleScroll);
  // }
  renderSuggestion = (suggestion, { query, isHighlighted }) => {
    const { marketplacePage, themeColor } = this.props;
    if ((marketplacePage && query.length >= 2) || (query.length >= 3 && !this.props.newsPage)) {
      const { classes, sanctionSearchPage } = this.props;
      const tooltipClass = {
        tooltip: themeColor === 'dark' ? classes.darkThemeRatingTooltip : classes.ratingTooltip,
        arrow: themeColor === 'dark' ? classes.darkThemeRatingArrow : classes.ratingArrow
      };

      let name = null;
      if (marketplacePage) {
        if (suggestion.companyName.indexOf(suggestion.shortName) !== -1)
          name = suggestion.companyName + " (" + suggestion.stockCode + ")"
        else
          name = suggestion.shortName + ": " + suggestion.companyName + " (" + suggestion.stockCode + ")"
      };
      const nameforMatching = sanctionSearchPage ? suggestion.name : marketplacePage ? name : suggestion.entityName;
      const matches = match(nameforMatching, query);
      const parts = parse(nameforMatching, matches);

      const roc = !sanctionSearchPage && suggestion.altNames ? suggestion.altNames.map(name => {
        if (name.type === 'REGIST' || name.type === "REGISTMA")
          return name.name;
        return null;
      }).filter(Boolean) : null;
      const prevName = !sanctionSearchPage && suggestion.altNames ? suggestion.altNames.map(name => {
        if (name.type === "PRVLEGAL")
          return name.name;
        return null;
      }).filter(Boolean) : null;
      // const stock = !sanctionSearchPage && suggestion.altNames ? suggestion.altNames.map(name => {
      //     if (name.type === "STOCKEX")
      //         return name.name;
      //     return null;
      // }).filter(Boolean) : null;
      const stock = !sanctionSearchPage && suggestion.stock ? suggestion.stock : null;
      const yob = !sanctionSearchPage && suggestion.yob ? suggestion.yob : null;
      const myCard = !sanctionSearchPage && suggestion.identification ? suggestion.identification.map(name => {
        if (name.type === 'MK')
          return name.idNo;
        return null;
      }).filter(Boolean) : null;

      const entityType = sanctionSearchPage ? suggestion.entityType : suggestion.type;
      const nationality = suggestion.incorpIso ? suggestion.incorpIso :
        suggestion.nationality ? suggestion.nationality[0] : null;
      // const imgOnLoad = nationality === '' ? '' : this.imgExist("/flag_org/drap_" + nationality + ".gif");
      const imgOnLoad = nationality !== '' && nationality !== 'UNK'
        && nationality !== 'KHM' && nationality !== 'IOT'
        && nationality !== 'JEY' && nationality !== 'MAF'
        && nationality !== 'XKX' && nationality !== 'KHM'
        && nationality !== 'UNK' && nationality !== 'SXM'
        && nationality !== 'NUK' && nationality !== 'CUW'
        && nationality !== 'KIR' && nationality !== 'TMP'
        && nationality !== 'SSD' && nationality !== 'TKL'
        && nationality !== 'SUN' && nationality !== 'SJM'
        && nationality !== 'SRB' && nationality !== 'MAC'
        && nationality !== 'SGS' && nationality !== 'BEN'
        && nationality !== 'TUV' && nationality !== 'ATA'
        && nationality !== 'WSM' && nationality !== 'ZAR'
        && nationality !== 'STP' && nationality !== 'SLB'
        && nationality !== 'HMD' && nationality !== 'DJI'
        && nationality !== 'GNB' && nationality !== 'IMN'
        && nationality !== 'BVT' && nationality !== 'VCT'
        && nationality !== 'YUG' && nationality !== 'ESH';
      const keyStyle = { paddingRight: "0px", fontSize: "16px" };
      const valueStyle = { paddingLeft: "0px" };

      const fullName = marketplacePage ? suggestion.companyName : null;
      const shortName = marketplacePage ? suggestion.shortName : null;
      const stockCode = marketplacePage ? suggestion.stockCode : null;
      const board = marketplacePage ? suggestion.board : null;

      return (
        <Tooltip arrow classes={tooltipClass} placement="right"
          title={
            <React.Fragment>
              <GridContainer
                direction="row"
                justify="center"
                spacing={1}
                className={classes.infoGrid}
              >
                {yob ?
                  <GridItem xs={4} sm={4} md={4} lg={4} className={classes.infoKey} style={keyStyle}>
                    <div style={{ flex: 1 }}>Year Of Birth</div>
                    <div>:</div>
                  </GridItem>
                  : ""}
                {yob ?
                  <GridItem xs={8} sm={8} md={8} lg={8} className={classes.infoValue} style={valueStyle}>
                    <div className={classes.innerContainer}>
                      -&nbsp;&nbsp;<p>{yob}</p>
                    </div>
                  </GridItem>
                  : ""}

                {myCard && myCard.length > 0 ?
                  <GridItem xs={4} sm={4} md={4} lg={4} className={classes.infoKey} style={keyStyle}>
                    <div style={{ flex: 1 }}>MyCard</div>
                    <div>:</div>
                  </GridItem>
                  : ""}
                {myCard && myCard.length > 0 ?
                  <GridItem xs={8} sm={8} md={8} lg={8} className={classes.infoValue} style={valueStyle}>
                    {myCard.map(number => {
                      return number.map((num, index) => {
                        return <div className={classes.innerContainer} key={index}>
                          -&nbsp;&nbsp;<p>{num}</p>
                        </div>
                      })
                    })}
                  </GridItem>
                  : ""}

                {roc && roc.length > 0 ?
                  <GridItem xs={4} sm={4} md={4} lg={4} className={classes.infoKey} style={keyStyle}>
                    <div style={{ flex: 1 }}>ROC</div>
                    <div>:</div>
                  </GridItem>
                  : ""}
                {roc && roc.length > 0 ?
                  <GridItem xs={8} sm={8} md={8} lg={8} className={classes.infoValue} style={valueStyle}>
                    {roc.map(number => {
                      return number.map((num, index) => {
                        return <div className={classes.innerContainer} key={index}>
                          -&nbsp;&nbsp;<p>{num}</p>
                        </div>
                      })
                    })}
                  </GridItem>
                  : ""}

                {stock && stock.length > 0 ?
                  <GridItem xs={4} sm={4} md={4} lg={4} className={classes.infoKey} style={keyStyle}>
                    <div style={{ flex: 1 }}>Stock</div>
                    <div>:</div>
                  </GridItem>
                  : ""}
                {stock && stock.length > 0 ?
                  <GridItem xs={8} sm={8} md={8} lg={8} className={classes.infoValue} style={valueStyle}>
                    {stock.map((data, index) => {
                      // return number.map((num, index) => {
                      return <div className={classes.innerContainer} key={index}>
                        -&nbsp;&nbsp;<p>{data.code} ({data.mic})</p>
                      </div>
                      // })
                    })}
                  </GridItem>
                  : ""}

                {prevName && prevName.length > 0 ?
                  <GridItem xs={4} sm={4} md={4} lg={4} className={classes.infoKey} style={keyStyle}>
                    <div style={{ flex: 1 }}>Historical Name</div>
                    <div>:</div>
                  </GridItem>
                  : ""}
                {prevName && prevName.length > 0 ?
                  <GridItem xs={8} sm={8} md={8} lg={8} className={classes.infoValue} style={valueStyle}>
                    {prevName.map(number => {
                      return number.map((num, index) => {
                        return <div className={classes.innerContainer} key={index}>
                          -&nbsp;&nbsp;<p>{num}</p>
                        </div>
                      })
                    })}
                  </GridItem>
                  : ""}

                {fullName && fullName.length > 0 ?
                  <GridItem xs={4} sm={4} md={4} lg={4} className={classes.infoKey} style={keyStyle}>
                    <div style={{ flex: 1 }}>Company Name</div>
                    <div>:</div>
                  </GridItem>
                  : ""}
                {fullName && fullName.length > 0 ?
                  <GridItem xs={8} sm={8} md={8} lg={8} className={classes.infoValue} style={valueStyle}>
                    {fullName}
                  </GridItem>
                  : ""}
                {shortName && shortName.length > 0 ?
                  <GridItem xs={4} sm={4} md={4} lg={4} className={classes.infoKey} style={keyStyle}>
                    <div style={{ flex: 1 }}>Stock Name</div>
                    <div>:</div>
                  </GridItem>
                  : ""}
                {shortName && shortName.length > 0 ?
                  <GridItem xs={8} sm={8} md={8} lg={8} className={classes.infoValue} style={valueStyle}>
                    {shortName}
                  </GridItem>
                  : ""}
                {stockCode && stockCode.length > 0 ?
                  <GridItem xs={4} sm={4} md={4} lg={4} className={classes.infoKey} style={keyStyle}>
                    <div style={{ flex: 1 }}>Stock Code</div>
                    <div>:</div>
                  </GridItem>
                  : ""}
                {stockCode && stockCode.length > 0 ?
                  <GridItem xs={8} sm={8} md={8} lg={8} className={classes.infoValue} style={valueStyle}>
                    {stockCode}
                  </GridItem>
                  : ""}
              </GridContainer>
            </React.Fragment>
          } disableHoverListener={!roc && !prevName && !stock && !yob && !fullName && !shortName && !stockCode}
          disableFocusListener={!roc && !prevName && !stock && !yob && !fullName && !shortName && !stockCode}>

          <MenuItem
            selected={isHighlighted}
            // divider='true'
            component="div"
            className={classes.resultList}
            onClick={(event) => this.handleClick(suggestion, event)}
            onAuxClick={(event) => this.handleClick(suggestion, event)}
          >
            <div className={classes.result_name}>
              {parts.map((part, i) => {
                return (
                  <span
                    key={part.text + i}
                    className={part.highlight ?
                      classes.highlightResult : classes.result}
                  >
                    {part.text}
                  </span>
                )
              })}
            </div>
            <div className={classes.result_code}>
              {entityType ? entityType : ""}
              {nationality && imgOnLoad && imgOnLoad !== '' ? " | " : ""}
              {nationality && imgOnLoad && imgOnLoad !== '' ? (
                <img
                  src={"/flag_org/drap_" + nationality + ".gif"}
                  alt={nationality}
                />) : ""
              }
              {board ? board : ""}
            </div>
          </MenuItem>
        </Tooltip>
      )
    }
  }
  onChange = (event, { newValue }) => {
    this.setState({ value: newValue });
  }
  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.handleScroll();
      this.handleSearch();
    }
  }
  onSuggestionsFetchRequested = ({ value }) => {
    const { sanctionSearchPage, sanctionSearchPageOption, newsPage, marketplacePage, currLocation } = this.props;

    clearTimeout(this.timer);
    if (marketplacePage && value.length < 2)
      this.onSuggestionsClearRequested();
    else if (value.length < 3)
      this.onSuggestionsClearRequested();
    this.timer = setTimeout(() => {
      if ((marketplacePage && value.length >= 2) || (value.length >= 3 && !newsPage)) {
        const { person, company, sanction } = this.props;
        // console.log(person, company)
        const per = person ? "PERS" : "";
        const com = company ? "COMP" : "";
        const locationString = this.props.generateString();
        // const searchIndices = sanctionSearchPage ? sanctionSearchPageOption : "names"
        let queryRequest;
        var search = {};
        // if ((person && !company) || (company && !person)) {
        //   search = sanctionSearchPage || sanction ? {
        //     size: 10,
        //     from: 0,
        //     filters: {
        //       entityType: ['INDV', 'COMP']
        //     },
        //     searchIndices: ["pep", "sanction"],
        //     keyword: value,
        //     keywordSearchFields: ["names", "names.phrase"],
        //     fuzzyKeywordSearchFields: ["names"],
        //     responseFields: [],
        //     excludedResponseFields: []
        //   } : {
        //     size: 30,
        //     from: 0,
        //     filters: {
        //       type: [per, com],
        //     },
        //     multiplier: {
        //       field: "relMultip"
        //     },
        //     searchIndices: ["names"],
        //     keyword: value,
        //     keywordSearchFields: ["names", "names.phrase"],
        //     fuzzyKeywordSearchFields: ["names"],
        //     responseFields: [],
        //     excludedResponseFields: []
        //   };
        // }
        // else if ((person && company) || !(person && company)) {
        //   search = sanctionSearchPage || sanction ? {
        //     size: 10,
        //     from: 0,
        //     filters: {
        //       entityType: ['INDV', 'COMP']
        //     },
        //     multiplier: {
        //       field: "relMultip"
        //     },
        //     searchIndices: ['pep', 'sanction'],
        //     fuzzy: false,
        //     keyword: value,
        //     keywordSearchFields: ["names", "names.phrase"],
        //     fuzzyKeywordSearchFields: ["names"],
        //     responseFields: [],
        //     excludedResponseFields: []
        //   } : {

        //     size: 30,
        //     from: 0,
        //     searchIndices: ["names"],
        //     multiplier: {
        //       field: "relMultip"
        //     },
        //     keyword: value,
        //     keywordSearchFields: ["names", "names.phrase"],
        //     fuzzyKeywordSearchFields: ["names"],
        //     responseFields: [],
        //     excludedResponseFields: []
        //   }
        // }
        // if (marketplacePage) {
        //   search = {
        //     size: 10,
        //     from: 0,
        //     searchIndices: ["stockprof"],
        //     keyword: value,
        //     keywordSearchFields: ["stockCode", "shortName", "companyName"],
        //     responseFields: [
        //       "stockCode",
        //       "shortName",
        //       "companyName",
        //       "mic",
        //       "operatingMic",
        //       "board",
        //       "sector",
        //       "subsector",
        //       "isMotherCode"
        //     ],
        //     excludedResponseFields: [],
        //   }
        // }
        search = {
          size: 30,
          from: 0,
          filters: {
            type: person && company ? ['COMP', 'PERS'] : person ? ['PERS'] : company ? ['COMP'] : ['COMP', 'INDV']
          },
          multiplier: {
            field: "relMultip"
          },
          searchIndices: ["names"],
          keyword: value,
          keywordSearchFields: ["names", "names.phrase"],
          fuzzyKeywordSearchFields: ["names"],
          responseFields: [],
          excludedResponseFields: []
        };
        // console.log(person, company, sanction, search, sanctionSearchPage, marketplacePage)
        if (sanction || sanctionSearchPage || marketplacePage) {
          queryRequest = this.searchService.esSearchWithAuth(search, currLocation, locationString);
        } else {
          // queryRequest = this.searchService.esSearchSuggest(search);
          queryRequest = this.searchService.esSearch(search, currLocation, locationString);
        }
        queryRequest
          .then(res => {
            let results = (res && res.data) ? res.data.data : [];
            results = results.sort((a, b) => {
              if (a._score < b._score)
                return 1;
              else if (a._score > b._score)
                return -1;
              else {
                if (a.entityName < b.entityName)
                  return -1;
                else if (a.entityName > b.entityName)
                  return 1;
                else {
                  if (a.externalId < b.externalId)
                    return -1;
                  else if (a.externalId > b.externalId)
                    return 1;
                  else
                    return 0;
                }
              }
            });
            this.setState({ suggestions: results }, () => {
              const { classes } = this.props;
              var container = document.getElementsByClassName(classes.container)[this.focusBox()];
              if (container)
                var expanded = container.getAttribute("aria-expanded");

              if (expanded === "true")
                this.setState({ expanded: true });
              else
                this.onSuggestionsClearRequested();
            });
          })
      }
    }, 100);
  }
  onSuggestionsClearRequested = () => {
    this.setState({ suggestions: [], expanded: false });
  }
  handleScroll = () => {
    const { classes } = this.props;
    var input = document.getElementsByClassName(classes.input);
    for (let i = 0; i < input.length; i++)
      input[i].blur();
    // input.blur();
    this.setState({ value: "" });
    this.onSuggestionsClearRequested();
  }
  handleClick = (value, event) => {
    const clickType = event.type;
    const { sanctionSearchPage, connectPage, bulkSearch, marketplacePage } = this.props;
    if (!this.props.relationship) {
      if (sanctionSearchPage) {
        const type = value.entityType === "COMP" ? "company/" : "person/";
        if (value.sanctionOrPep === "S") {
          if (clickType === 'click')
            this.props.history.push("/sanction" + type + value.id);
          else
            window.open("/sanction" + type + value.id, '_blank');
        } else {
          if (clickType === 'click')
            this.props.history.push("/pepPage/" + value.id);
          else
            window.open("/pepPage/" + value.id, '_blank');
        }
      }
      // else if (connectPage || (roles.indexOf('G_CONN') === 1 && roles.indexOf('G_INTEL') === -1))
      else if (connectPage) {
        if (clickType === 'click')
          this.props.history.push("/connect/" + (
            value.type === "PERS" ? "person/" :
              value.type === "COMP" ? "company/" : "") + value.externalId);
        else
          window.open("/connect/" + (
            value.type === "PERS" ? "person/" :
              value.type === "COMP" ? "company/" : "") + value.externalId, '_blank');
      }
      else if (marketplacePage) {
        if (clickType === 'click')
          this.props.history.push("/individualstock/" + value.trackingId);
        // this.props.history.push("/allmarketplace/" + value.trackingId);
        else
          window.open("/individualstock/" + value.trackingId, '_blank');
        // window.open("/allmarketplace/" + value.trackingId, '_blank');
      }
      else {
        // if (roles && (roles.indexOf('G_CONN') === 1 && roles.indexOf('G_INTEL') === -1))
        //     this.props.handleSearchType("connect");

        if (clickType === 'click')
          this.props.history.push("/" + (
            value.type === "PERS" ? "person/" :
              value.type === "COMP" ? "company/" : "") + value.externalId);
        else
          window.open("/" + (
            value.type === "PERS" ? "person/" :
              value.type === "COMP" ? "company/" : "") + value.externalId, '_blank');
      }
      this.setState({ value: "", suggestions: [] });
    }
    else {
      if (bulkSearch)
        this.props.addBulkSearch({ id: value.id, name: value.entityName, domicileIso: value.domicileIso, type: value.type });
      else {
        var type = value.type === "PERS" ? "Person" : value.type === "COMP" ? "Company" : "";
        this.props.getConnectivity(value.id, type);
      }
    }
  }
  handleSearch = () => {
    const { value } = this.state;
    const { sanctionSearchPage, relationship, connectPage, newsPage, marketplacePage } = this.props;
    if (newsPage) {
      if (value && value !== "")
        this.props.history.push("/webcrawlerpage/" + value);
      else
        this.props.history.push("/webcrawlerpage/_");
    }
    // else if (connectPage || (roles.indexOf('G_CONN') === 1 && roles.indexOf('G_INTEL') === -1)) {
    else if (connectPage) {
      if (value && value !== "")
        this.props.history.push("/connectivity/" + value);
      else
        this.props.history.push("/connectivity/_");
    }
    else if (relationship) {
      if (value && value !== "")
        this.props.getAdvancedSearch(value);
    }
    else if (marketplacePage) {
      if (value && value !== "")
        this.props.history.push("/bursa/" + value);
      else
        this.props.history.push("/bursa/_");
    }
    else {
      const searchUrl = sanctionSearchPage ? "/searchSanction/" : "/searchPage/";
      // if ((roles.indexOf('G_CONN') === 1 && roles.indexOf('G_INTEL') === -1))
      //     this.props.handleSearchType("connect");
      if (value && value !== "")
        this.props.history.push(searchUrl + value);
      else
        this.props.history.push(searchUrl + "_");
    }
    this.setState({ value: "" });
  }
  isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }

  handleChange = (name) => event => {
    const { person, company, sanction } = this.props;
    if (name === "all") {
      this.props.handleCheckBox(name, !person, !company);
      this.onSuggestionsFetchRequested({ value: this.state.value });
    }
    if (name === "person") {
      this.props.handleCheckBox(name, !person);
      this.onSuggestionsFetchRequested({ value: this.state.value });
    }
    else if (name === "company") {
      this.props.handleCheckBox(name, !company);
      this.onSuggestionsFetchRequested({ value: this.state.value });
    }
    else if (name === "sanction") {
      this.props.handleCheckBox(name, !sanction);
      this.onSuggestionsFetchRequested({ value: this.state.value });
    }
  }


  focusBox = () => {
    const { classes, hidden, relationship, small } = this.props;
    var input = document.getElementsByClassName(classes.input);

    let num = 0;
    if (input.length === 1)
      num = 0;
    else if ((input.length === 2 || input.length === 3) && hidden)
      num = 0;
    else if (input.length === 3 && relationship)
      num = 2;
    else if (input.length === 3 && small)
      num = 2;
    else if (input.length === 4 && small)
      num = 3;
    else
      num = 1;
    input[num].focus();

    return num;
  }
  imgExist = (url) => {
    var http = new XMLHttpRequest();

    http.open('HEAD', url, false);
    http.send();

    return http.status !== 404;
  }
  redirect = (url) => {
    this.props.history.push(url);
  }
  checkBrokerRole = (role) => {
    const { roles } = this.props;
    if (roles.includes('SUPER_DASHBRD') || roles.includes('ADMIN') || roles.filter(data => data.indexOf(role) !== -1).length > 0)
      return true;
    return false;
  }
  checkMarkplcRole = (role) => {
    const { roles } = this.props;
    if (roles.includes('SUPER_MARKP') || roles.includes('ADMIN') || roles.filter(data => data.indexOf(role) !== -1).length > 0)
      return true;
    return false;
  }
  checkRoles = () => {
    return (this.checkBrokerRole('B_DASHBRD') || this.checkMarkplcRole('B_MARKP') || this.checkMarkplcRole('B_RETAIL') || this.checkMarkplcRole('B_FOREIGN'));
  }

  render() {
    const {
      classes,
      search,
      style,
      person,
      company,
      sanction,
      hidden,
      small,
      searchPage,
      newsPage,
      connectivityPage,
      connectResult,
      notHomePage,
      relationship,
      isFullScreen,
      handleSearchType,
      authenticated,
      username,
      getLoadedData,
      roles,
      marketplacePage,
      // sanctionSearchPage,
      insiderHome,
      themeColor
    } = this.props;
    const { value, suggestions, expanded } = this.state;
    const inputProps = {
      placeholder: "Search",
      value,
      onChange: this.onChange,
      onKeyDown: this.handleKeyDown,
      className: classes.input,
    }
    const inputPropsNotAuth = {
      placeholder: "Company Search",
      value,
      onChange: this.onChange,
      onKeyDown: this.handleKeyDown,
      className: classes.input,
    }
    const mainContainer = classNames({
      [classes.mainContainer]: true,
      // [classes.overflowHidden]: this.isEmpty(suggestions),
      [classes.hiddenContainer]: hidden,
      [classes.searchMainContainer]: searchPage,
      [classes.smallContainer]: small,
      [classes.searchMainContainer]: newsPage,
      [classes.relationshipContainer]: relationship,
      [classes.connectContainer]: connectResult,
      [classes.isFullScreen]: isFullScreen && !relationship,
      [classes.insiderHomeContainer]: insiderHome
    });
    const searchBoxContainer = classNames({
      [classes.searchBoxContainer]: true,
      [classes.hiddenSearchContainer]: hidden || small || searchPage,
      [classes.containerHide]: !search || (searchPage && hidden),
      [classes.searchContainer]: newsPage || connectResult || marketplacePage,
      [classes.relationship]: relationship,
      [classes.relationFullScreen]: isFullScreen && relationship,
      [classes.insiderHomeSearchBoxContainer]: insiderHome
    });
    const gridContainer = classNames({
      [classes.gridContainer]: true,
      [classes.defaultGrid]: hidden || small || newsPage || connectResult || marketplacePage,
    });
    // const homeLogo = classNames({
    //     [classes.homeLogo]: true,
    //     [classes.hiddenLogo]: hidden || small,
    // });
    const root = classNames({
      [classes.root]: true,
      [classes.root__open]: expanded,
      [classes.rootHidden]: hidden,
      [classes.rootSmall]: small,
      [classes.darkThemeRoot]: themeColor === 'dark',
      [classes.insiderHomeRoot]: insiderHome
    });
    const suggestionsContainerOpen = classNames({
      [classes.suggestionsContainerOpen]: !newsPage,
      [classes.smallSuggestionOpen]: small,
      // [classes.relationshipSuggestionOpen]: relationship,
      [classes.marketplaceSuggestionOpen]: marketplacePage,
      [classes.darkThemeSuggestionOpen]: themeColor === 'dark',
    });
    const suggestionsContainerOpenNotAuth = classNames({
      [classes.suggestionsContainerOpenNotAuth]: !newsPage,
      [classes.smallSuggestionOpen]: small,
      // [classes.relationshipSuggestionOpen]: relationship,
      [classes.marketplaceSuggestionOpen]: marketplacePage,
      [classes.darkThemeSuggestionOpen]: themeColor === 'dark',
    });
    const iconContainer = classNames({
      [classes.iconContainer]: true,
      [classes.smallIcon]: small
    });
    // const personClass = classNames({
    //     [classes.iconButton]: true,
    //     [classes.selectedIcon]: !person
    // });
    // const companyClass = classNames({
    //     [classes.iconButton]: true,
    //     [classes.selectedIcon]: !company
    // });
    const searchClass = classNames({
      [classes.iconButton]: true,
      [classes.darkIcon]: themeColor === 'dark',
      // [classes.hideIcon]: relationship
    });
    return (

      <div className={mainContainer}>
        <div className={searchBoxContainer} ref="container" style={{ ...style }}>
          {/* {!hidden && !small && !notHomePage && !relationship ? <FeatureSector handleSearchType={handleSearchType} authenticated={authenticated} username={username} roles={roles} /> : ""} */}
          <GridContainer justify={"center"} className={gridContainer}>
            <GridItem xs={11} sm={12} md={12}>
              <Paper className={root}>
                <AutoSuggest
                  suggestions={suggestions}
                  onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                  onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                  getSuggestionValue={suggestion => suggestion.name ? suggestion.name.trim() : "".trim()}
                  renderSuggestion={this.renderSuggestion}
                  inputProps={inputProps}
                  renderSuggestionsContainer={options => (
                    <div {...options.containerProps}>
                      <div >
                        {(options.children) ?
                          <AppBar position="sticky" color="white">
                            <Tabs
                              value={[]}
                              indicatorColor="secondary"
                              indeterminate
                            >
                              {authenticated ?
                                <Tab
                                  onClick={this.handleChange('all')}
                                  className={person && company ? classes.tabsSelected : classes.tabsNotSelected}
                                  label="All"
                                // disableFocusRipple={!person && !company ? true : false}
                                />
                                : ""}

                              <Tab
                                onClick={this.handleChange('company')}
                                className={company ? classes.tabsSelected : classes.tabsNotSelected}
                                label="Company"
                              // disableFocusRipple={!person ? true : false}
                              // disabled={!person ? true : false}
                              />
                              <Tab
                                onClick={this.handleChange('person')}
                                className={person ? classes.tabsSelected : classes.tabsNotSelected}
                                label="Person"
                              // disableFocusRipple={!company ? true : false}
                              // disabled={!company ? true : false}
                              />
                              {/* <Tab
                                onClick={this.handleChange('sanction')}
                                className={sanction ? classes.tabsSelected : classes.tabsNotSelected}
                                // disableFocusRipple={!sanction ? true : false}
                                label="Sanction/PEP"
                              /> */}
                            </Tabs>
                            {(options.children)}
                          </AppBar> : ""
                        }
                      </div>
                      <div >

                      </div>
                    </div>
                  )}
                  theme={{
                    container: classes.container,
                    suggestionsContainerOpen: suggestionsContainerOpen,
                    suggestionsList: classes.suggestionsList,
                    suggestion: classes.suggestion
                  }}
                />
                <div className={iconContainer}>
                  {/* <Divider className={classes.divider} />
                                    {!newsPage && !marketplacePage ? <Tooltip title="Trigger Person">
                                        <IconButton
                                            className={personClass}
                                            aria-label="Person"
                                            onClick={() => this.handleIconClick("person")}
                                        >
                                            <Person className={classes.icon} />
                                        </IconButton>
                                    </Tooltip> : ""}
                                    {!newsPage && !marketplacePage ? <Divider className={classes.divider} /> : ""}

                                    {!newsPage && !marketplacePage ? <Tooltip title={"Trigger Company"}>
                                        <IconButton
                                            className={companyClass}
                                            aria-label="Company"
                                            onClick={() => this.handleIconClick("company")}
                                        >
                                            <Company className={classes.icon} />
                                        </IconButton>
                                    </Tooltip> : ""}
                                    {!newsPage && !marketplacePage ? <Divider className={classes.divider} /> : ""} */}
                  <IconButton
                    className={searchClass}
                    aria-label="Search"
                    onClick={this.handleSearch}
                  >
                    <SearchIcon className={searchClass + " " + classes.icon} />
                  </IconButton>
                  {small ? <Divider className={classes.divider} /> : ""}
                </div>
              </Paper>
              {/* {!hidden && !small && !notHomePage && !relationship ? <h4 style={{textAlign: "center", fontWeight: "400", color: "grey", marginBlockStart: "8px", marginBlockEnd: "0px", fontSize: "14px"}}>Gateway to Global Insights</h4> : ""} */}
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
};
export default withStyles(style)(SearchBox);